import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import type { ProviderZonesList, CreateProviderZoneDto } from "@reactive-resume/dto";

const createProviderZones = async (data: CreateProviderZoneDto) => {
  const response = await axios.post("/provider/zone", data);
  return response.data;
};

export const useCreateProviderZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateProviderZoneDto) => createProviderZones(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providerZones"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
